// 기상청 API 관련 코드/상수 (git 4204c3b^:src/common/common.js 에서 복원)

// 단기예보 발표 시각 (매일 8회, 02시부터 3시간 간격)
export const SHORT_WEATHER_BASE_TIME = ["0200", "0500", "0800", "1100", "1400", "1700", "2000", "2300"];

// 중기예보 육상 권역코드 (regId) — 주소 문자열 매칭, 강원은 include로 영동/영서 구분
export const MID_WEATHER_CODE = [
            {key:"서울", code : "11B00000"},
            {key:"인천", code : "11B00000"},
            {key:"경기도", code : "11B00000"},
            {key:"강원도", code : "11D20000", include:["고성", "속초", "양양", "강릉", "동해", "삼척", "태백"]},
            {key:"강원도", code : "11D10000"},
            {key:"대전", code : "11C20000"},
            {key:"세종", code : "11C20000"},
            {key:"충청남도", code : "11C20000"},
            {key:"충남", code : "11C20000"},
            {key:"충청북도", code : "11C10000"},
            {key:"충북", code : "11C10000"},
            {key:"광주", code : "11F20000"},
            {key:"전라남도", code : "11F20000"},
            {key:"전남", code : "11F20000"},
            {key:"전라북도", code : "11F10000"},
            {key:"전북", code : "11F10000"},
            {key:"대구", code : "11H10000"},
            {key:"경상북도", code : "11H10000"},
            {key:"경북", code : "11H10000"},
            {key:"부산", code : "11H20000"},
            {key:"울산", code : "11H20000"},
            {key:"경상남도", code : "11H20000"},
            {key:"경남", code : "11H20000"},
            {key:"제주도", code : "11G00000"},
];
export const MID_TEMP_CODE = [
            {key:'가평',code:'11B20404'},
            {key:'강계',code:'11J10005'},
            {key:'강릉',code:'11D20501'},
            {key:'강진',code:'11F20303'},
            {key:'강화',code:'11B20101'},
            {key:'개성',code:'11I20002'},
            {key:'거제',code:'11H20403'},
            {key:'거창',code:'11H20502'},
            {key:'경산',code:'11H10703'},
            {key:'경주',code:'11H10202'},
            {key:'계룡',code:'11C20403'},
            {key:'고령',code:'11H10604'},
            {key:'고산',code:'11G00501'},
            {key:'고성',code:'11D20402',include:['강원도']},
            {key:'고성',code:'11H20404',include:['경상남도']},
            {key:'고성(장전)',code:'11L10002'},
            {key:'고양',code:'11B20302'},
            {key:'고창',code:'21F10601'},
            {key:'고흥',code:'11F20403'},
            {key:'곡성',code:'11F20602'},
            {key:'공주',code:'11C20402'},
            {key:'과천',code:'11B10102'},
            {key:'광명',code:'11B10103'},
            {key:'광양',code:'11F20402'},
            {key:'광주',code:'11B20702'},
            {key:'광주',code:'11F20501'},
            {key:'괴산',code:'11C10303'},
            {key:'구례',code:'11F20601'},
            {key:'구리',code:'11B20501'},
            {key:'구미',code:'11H10602'},
            {key:'구성',code:'11J10003'},
            {key:'군산',code:'21F10501'},
            {key:'군위',code:'11H10603'},
            {key:'군포',code:'11B20610'},
            {key:'금산',code:'11C20601'},
            {key:'김제',code:'21F10502'},
            {key:'김천',code:'11H10601'},
            {key:'김포',code:'11B20102'},
            {key:'김해',code:'11H20304'},
            {key:'나주',code:'11F20503'},
            {key:'남양주',code:'11B20502'},
            {key:'남원',code:'11F10401'},
            {key:'남해',code:'11H20405'},
            {key:'논산',code:'11C20602'},
            {key:'단양',code:'11C10202'},
            {key:'담양',code:'11F20504'},
            {key:'당진',code:'11C20103'},
            {key:'대관령',code:'11D20201'},
            {key:'대구',code:'11H10701'},
            {key:'대전',code:'11C20401'},
            {key:'독도',code:'11E00102'},
            {key:'동두천',code:'11B20401'},
            {key:'동해',code:'11D20601'},
            {key:'목포',code:'21F20801'},
            {key:'무산(삼지연)',code:'11K10004'},
            {key:'무안',code:'21F20804'},
            {key:'무주',code:'11F10302'},
            {key:'문경',code:'11H10301'},
            {key:'밀양',code:'11H20601'},
            {key:'백령도',code:'11A00101'},
            {key:'보령',code:'11C20201'},
            {key:'보성',code:'11F20404'},
            {key:'보은',code:'11C10302'},
            {key:'봉화',code:'11H10402'},
            {key:'부산',code:'11H20201'},
            {key:'부안',code:'21F10602'},
            {key:'부여',code:'11C20501'},
            {key:'부천',code:'11B20204'},
            {key:'북청(신포)',code:'11K20003'},
            {key:'사리원',code:'11I10001'},
            {key:'사천',code:'11H20402'},
            {key:'삭주(수풍)',code:'11J10002'},
            {key:'산청',code:'11H20703'},
            {key:'삼척',code:'11D20602'},
            {key:'상주',code:'11H10302'},
            {key:'서귀포',code:'11G00401'},
            {key:'서산',code:'11C20101'},
            {key:'서울',code:'11B10101'},
            {key:'서천',code:'11C20202'},
            {key:'성남',code:'11B20605'},
            {key:'성산',code:'11G00101'},
            {key:'성주',code:'11H10605'},
            {key:'성진(김책)',code:'11K10003'},
            {key:'성판악',code:'11G00302'},
            {key:'세종',code:'11C20404'},
            {key:'속초',code:'11D20401'},
            {key:'수원',code:'11B20601'},
            {key:'순창',code:'11F10403'},
            {key:'순천',code:'11F20603'},
            {key:'순천시',code:'11F20405'},
            {key:'시흥',code:'11B20202'},
            {key:'신계',code:'11I10002'},
            {key:'신안',code:'21F20803'},
            {key:'신의주',code:'11J10001'},
            {key:'아산',code:'11C20302'},
            {key:'안동',code:'11H10501'},
            {key:'안산',code:'11B20203'},
            {key:'안성',code:'11B20611'},
            {key:'안양',code:'11B20602'},
            {key:'안주',code:'11J20004'},
            {key:'양구',code:'11D10202'},
            {key:'양덕',code:'11J20005'},
            {key:'양산',code:'11H20102'},
            {key:'양양',code:'11D20403'},
            {key:'양주',code:'11B20304'},
            {key:'양평',code:'11B20503'},
            {key:'여수',code:'11F20401'},
            {key:'여주',code:'11B20703'},
            {key:'연천',code:'11B20402'},
            {key:'영광',code:'21F20102'},
            {key:'영덕',code:'11H10102'},
            {key:'영동',code:'11C10402'},
            {key:'영암',code:'21F20802'},
            {key:'영양',code:'11H10403'},
            {key:'영월',code:'11D10501'},
            {key:'영주',code:'11H10401'},
            {key:'영천',code:'11H10702'},
            {key:'예산',code:'11C20303'},
            {key:'예천',code:'11H10303'},
            {key:'오산',code:'11B20603'},
            {key:'옥천',code:'11C10403'},
            {key:'완도',code:'11F20301'},
            {key:'완주',code:'11F10204'},
            {key:'용인',code:'11B20612'},
            {key:'울릉도',code:'11E00101'},
            {key:'울산',code:'11H20101'},
            {key:'울진',code:'11H10101'},
            {key:'웅기(선봉)',code:'11K10002'},
            {key:'원산',code:'11L10001'},
            {key:'원주',code:'11D10401'},
            {key:'음성',code:'11C10103'},
            {key:'의령',code:'11H20602'},
            {key:'의성',code:'11H10502'},
            {key:'의왕',code:'11B20609'},
            {key:'의정부',code:'11B20301'},
            {key:'이어도',code:'11G00601'},
            {key:'이천',code:'11B20701'},
            {key:'익산',code:'11F10202'},
            {key:'인제',code:'11D10201'},
            {key:'인천',code:'11B20201'},
            {key:'임실',code:'11F10402'},
            {key:'자성(중강)',code:'11J10004'},
            {key:'장성',code:'11F20502'},
            {key:'장수',code:'11F10301'},
            {key:'장연(용연)',code:'11I20003'},
            {key:'장진',code:'11K20002'},
            {key:'장흥',code:'11F20304'},
            {key:'전주',code:'11F10201'},
            {key:'정선',code:'11D10502'},
            {key:'정읍',code:'11F10203'},
            {key:'제주',code:'11G00201'},
            {key:'제천',code:'11C10201'},
            {key:'증평',code:'11C10304'},
            {key:'진남포(남포)',code:'11J20002'},
            {key:'진도',code:'21F20201'},
            {key:'진안',code:'11F10303'},
            {key:'진주',code:'11H20701'},
            {key:'진천',code:'11C10102'},
            {key:'창녕',code:'11H20604'},
            {key:'창원',code:'11H20301'},
            {key:'천안',code:'11C20301'},
            {key:'철원',code:'11D10101'},
            {key:'청도',code:'11H10704'},
            {key:'청송',code:'11H10503'},
            {key:'청양',code:'11C20502'},
            {key:'청주',code:'11C10301'},
            {key:'청진',code:'11K10001'},
            {key:'추자도',code:'11G00800'},
            {key:'추풍령',code:'11C10401'},
            {key:'춘천',code:'11D10301'},
            {key:'충주',code:'11C10101'},
            {key:'칠곡',code:'11H10705'},
            {key:'태백',code:'11D20301'},
            {key:'태안',code:'11C20102'},
            {key:'통영',code:'11H20401'},
            {key:'파주',code:'11B20305'},
            {key:'평강',code:'11L10003'},
            {key:'평양',code:'11J20001'},
            {key:'평창',code:'11D10503'},
            {key:'평택',code:'11B20606'},
            {key:'포천',code:'11B20403'},
            {key:'포항',code:'11H10201'},
            {key:'풍산',code:'11K20005'},
            {key:'하남',code:'11B20504'},
            {key:'하동',code:'11H20704'},
            {key:'함안',code:'11H20603'},
            {key:'함양',code:'11H20501'},
            {key:'함평',code:'21F20101'},
            {key:'함흥',code:'11K20001'},
            {key:'합천',code:'11H20503'},
            {key:'해남',code:'11F20302'},
            {key:'해주',code:'11I20001'},
            {key:'혜산',code:'11K20004'},
            {key:'홍성',code:'11C20104'},
            {key:'홍천',code:'11D10302'},
            {key:'화성',code:'11B20604'},
            {key:'화순',code:'11F20505'},
            {key:'화천',code:'11D10102'},
            {key:'횡성',code:'11D10402'},
            {key:'흑산도',code:'11F20701'},
            {key:'희천',code:'11J10006'},
];
